import { useState, useEffect } from "react";
import { useAuth } from "@api/useAuth";
import { useCashTransactions } from "@api/hooks";
import AlertModal from "./AlertModal";

export default function PendingHandoffAlert() {
  const { user, isLoading: authLoading } = useAuth();
  const [open, setOpen] = useState(false);

  const { data } = useCashTransactions(
    { mine: "true", as: "receiver", status: "pending", limit: 1 },
    { enabled: !!user && !authLoading },
  );

  useEffect(() => {
    if (data?.count > 0) setOpen(true);
  }, [data?.count]);

  if (!open) return null;

  const count = data?.count ?? 0;

  return (
    <AlertModal isOpen={open} onClose={() => setOpen(false)} title="Pending Cash Hand-off">
      <p className="text-smiles-darkGray">
        You have <span className="font-semibold text-palette-yellow-secondary">{count}</span>{" "}
        pending cash hand-off{count !== 1 ? "s" : ""} waiting for your confirmation or rejection.
        Please visit <span className="font-medium">Cash Management</span> to action them.
      </p>
    </AlertModal>
  );
}
